export const STRING_CONSTANTS = {
  missingDataString: '-',
};
